import React, { useState, useEffect, createContext } from 'react';
import FullPageLoader from '../components/general/FullPageLoader';

export const PsychometricContext = createContext();

export default ({ children }) => {
    const [signedOrganization, setSignedOrganization] = useState(null); 
    const [signedEmail, setSignedEmail] = useState(null); 
    const [signedMobile, setSignedMobile] = useState(null); 
    const [signedID, setSignedID]= useState(null);
    const [signedFirstName, setSignedFirstName]= useState(null);
    const [signedLastName, setSignedLastName]= useState(null);
    const [isLoaded, setIsLoaded] = useState(false); 
    const [isStudent, setIsStudent] = useState(null);
    const [signedPassword, setSignedPassword] = useState(null); 
    const [isOrganization, setIsOrganization] = useState(null); 
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        if (isOrganization) {
            localStorage.setItem('isOrganization', isOrganization);
        }
        console.log("set local storage", isOrganization);
    }, [isOrganization]);

    useEffect(() => {
        const tempIsOrganization = localStorage.getItem('isOrganization');
        console.log("get local storage", tempIsOrganization);
        if (tempIsOrganization) {
            setIsOrganization(tempIsOrganization);
        }
    }, []);


    useEffect(() => {
        if (isStudent) {
            localStorage.setItem('isStudent', isStudent);
        }
        console.log("set local storage", isStudent);
    }, [isStudent]);

    useEffect(() => {
        const tempIsStudent = localStorage.getItem('isStudent');
        console.log("get local storage", tempIsStudent);
        if (tempIsStudent) {
            setIsStudent(tempIsStudent);
        }
    }, []);

    useEffect(() => {
        if (signedFirstName) {
            localStorage.setItem('signedFirstName', signedFirstName);
        }
        console.log("set local storage", signedFirstName);
    }, [signedFirstName]);

    useEffect(() => {
        const tempFirstName = localStorage.getItem('signedFirstName');
        console.log("get local storage", tempFirstName);
        if (tempFirstName) {
            setSignedFirstName(tempFirstName);
        }
    }, []);

    useEffect(() => {
        if (signedLastName) {
            localStorage.setItem('signedLastName', signedLastName);
        }
        console.log("set local storage", signedLastName);
    }, [signedLastName]);

    useEffect(() => {
        const tempLastName = localStorage.getItem('signedLastName');
        console.log("get local storage", tempLastName);
        if (tempLastName) {
            setSignedLastName(tempLastName);
        }
    }, []);


    useEffect(() => {
        if (signedID) {
            localStorage.setItem('signedId', signedID);
        }
        console.log("set local storage", signedID);
    }, [signedID]);

    useEffect(() => {
        const tempId = localStorage.getItem('signedId');
        console.log("get local storage", tempId);
        if (tempId) {
            setSignedID(tempId);
        }
    }, []);




    useEffect(() => {
        if (signedPassword) {
            localStorage.setItem('signedPassword', signedPassword);
        }
        console.log("set local storage", signedPassword);
    }, [signedPassword]);

    useEffect(() => {
        const tempPassword = localStorage.getItem('signedPassword');
        console.log("get local storage", tempPassword);
        if (tempPassword) {
            setSignedPassword(tempPassword);
        }
    }, []);



    useEffect(() => {
        if (signedOrganization) {
            localStorage.setItem('signedOrganization', signedOrganization);
        }
        console.log("set local storage", signedOrganization);
    }, [signedOrganization]);

    useEffect(() => {
        const tempOrganization = localStorage.getItem('signedOrganization');
        console.log("get local storage", tempOrganization);
        if (tempOrganization) {
            setSignedOrganization(tempOrganization);
        }
    }, []);

    useEffect(() => {
        if (signedEmail) {
            localStorage.setItem('signedEmail', signedEmail);
        }
        console.log("set local storage", signedEmail);
    }, [signedEmail]);

    useEffect(() => {
        const tempEmail = localStorage.getItem('signedEmail');
        console.log("get local storage", tempEmail);
        if (tempEmail) {
            setSignedEmail(tempEmail);
        }
    }, []);

    useEffect(() => {
        if (signedMobile) {
            localStorage.setItem('signedMobile', signedMobile);
        }
        console.log("set local storage", signedMobile);
    }, [signedMobile]);

    useEffect(() => {
        const tempMobile = localStorage.getItem('signedMobile');
        console.log("get local storage", tempMobile);
        if (tempMobile) {
            setSignedMobile(tempMobile);
        }
    }, []);

    useEffect(() => {
        if (signedOrganization && signedEmail && signedMobile) {
            setIsLoaded(true);
        }
        else{

            setIsLoaded(false);
        }
    }, [signedOrganization, signedEmail, signedMobile]);

    // Add authentication check helper
    const checkAuthentication = () => {
        const storedEmail = localStorage.getItem('signedEmail');
        const storedIsOrg = localStorage.getItem('isOrganization');
        
        // Clear everything if partial state exists
        if (!storedEmail || !storedIsOrg) {
            localStorage.removeItem('signedEmail');
            localStorage.removeItem('isOrganization');
            localStorage.removeItem('signedFirstName');
            localStorage.removeItem('signedLastName');
            localStorage.removeItem('signedId');
            setSignedEmail(null);
            setIsOrganization(null);
            setSignedFirstName(null);
            setSignedLastName(null);
            setSignedID(null);
        }
    };

    // Add effect to check authentication on mount
    useEffect(() => {
        checkAuthentication();
    }, []);

    // Effect for organization
    useEffect(() => {
        if (signedOrganization) {
            sessionStorage.setItem('signedOrganization', signedOrganization);
        }
    }, [signedOrganization]);

    // Effect for email
    useEffect(() => {
        if (signedEmail) {
            sessionStorage.setItem('signedEmail', signedEmail);
        }
    }, [signedEmail]);

    // Effect to load from sessionStorage on mount
    useEffect(() => {
        const storedOrg = sessionStorage.getItem('signedOrganization');
        const storedEmail = sessionStorage.getItem('signedEmail');
        
        if (storedOrg) setSignedOrganization(storedOrg);
        if (storedEmail) setSignedEmail(storedEmail);
    }, []);

    // Add a logout function to clear everything
    const logout = () => {
        sessionStorage.removeItem('signedOrganization');
        sessionStorage.removeItem('signedEmail');
        // ... clear other session storage items ...
        setSignedOrganization(null);
        setSignedEmail(null);
        // ... reset other state ...
    };

    return (
        //!isLoaded ? <FullPageLoader /> :
        <PsychometricContext.Provider value={{ signedEmail, signedOrganization, signedMobile,signedPassword, signedID,signedFirstName, signedLastName, isStudent, isOrganization, setSignedEmail,setSignedMobile,setSignedOrganization, setSignedPassword, setSignedID, setSignedFirstName, setSignedLastName, setIsStudent, setIsOrganization, logout }}>
            {children}
        </PsychometricContext.Provider>
    )
};

